import React from "react";
import { Button, Spinner } from "reactstrap";

const GeneralButton = ({
  className,
  title,
  handleClick,
  width,
  height,
  icon,
  loading,
  disabled,
}) => {
  return (
    <Button
      className={className}
      onClick={handleClick}
      style={{ width: width, height: height }}
      disabled={disabled}
    >
      {loading ? (
        <Spinner size={"sm"} />
      ) : (
        <>
          {icon && <span className="mx-1">{icon}</span>}
          {title}
        </>
      )}
    </Button>
  );
};

export default GeneralButton;
